module.exports = __webpack_public_path__ + "static/img/cha2.4faebf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/cha2.png
// module id = SdQw
// module chunks = 1